export default {"src":"/_next/static/media/booty.313bbc3e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};